export default __webpack_public_path__ + "static/media/Gyas's Fetters.f7144ac5.jpg";